<template>
    <popup-modal ref="popup">
        <div class="warning-modal">
            <a href="javascript:void(0)" class="close-modal">
                <img @click="closeModal" :src="closeImg" alt="Close">
            </a>
            <h2 class="title">{{ title }}</h2>
            <div class="content">
                {{ content }}
            </div>
            <div class="bottom">
                <button @click="closeModal">Got it</button>
            </div>
        </div>
    </popup-modal>
</template>

<script>
import PopupModal from '../../modal.vue'
export default {
    name: "Warning",
    components: { PopupModal },
    data: () => ({
        closeImg: '/themes/web/assets/images/icon/icon-closed-1.png',
        title: undefined,
        content: undefined,
        resolvePromise: undefined,
    }),
    mounted() {

    },
    created() {

    },
    methods: {
        show(opts = {}) {
            this.title = opts.title
            this.content = opts.content
            this.$refs.popup.open()
            return new Promise((resolve, reject) => {
                this.resolvePromise = resolve;
            });
        },
        closeModal() {
            this.resolvePromise(true);
            this.$refs.popup.close();
        }
    },
}
</script>

<style scoped>
.warning-modal {
    width: 600px;
    position: relative;
    padding: 24px 48px;
}

.title {
    letter-spacing: 0.02em;
    color: #000000;
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    margin-bottom: 20px;
}

.close-modal {
    position: absolute;
    display: flex;
    justify-self: flex-end;
    justify-content: flex-end;
    right: 0;
    cursor: default;
    top: 0;
}

.close-modal img {
    cursor: pointer;
}

.content {
    letter-spacing: 0.02em;
    color: #0D0D0C;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 300;
    letter-spacing: 0.02em;
    color: #1D1D1F;
    line-height: 25px;
    text-align: center;
}

.bottom {
    display: flex;
    justify-content: center;
    margin-top: 16px;
}

.bottom button {
    width: 100%;
    border-radius: 48px;
    height: 52px;
    font-weight: 700;
    font-size: 16px;
    color: #191715;
    text-align: center;
    cursor: pointer;
}

.bottom button:nth-child(1) {
    margin-top: 20px;
    background: #F8FE5F;
    border: 1px solid #E3E87A;
    width: 300px;
    box-shadow: 0px 0px 16px #F8FE5F, 4px 4px 0px #E3E87A;
}
</style>